export function getFileExtension(fileName: string): string {
  return fileName.lastIndexOf('.') !== -1 ? fileName.substring(fileName.lastIndexOf('.') + 1) : '';
}
